<template src="../templates/printBookings.html"></template>

<script>
    import DynamicBookingDetail from "./DynamicBookingDetail";
    import Axios from 'axios'
    import moment from 'moment';

    export default {
        name: "PrintBookingsComponent",
        components: {DynamicBookingDetail},
        props: ["jobsToPrint"],
        data() {
            return {
                loadingJobs: true,
                isDownloading: false,
                jobsLoaded: 0
            }

        },
        methods: {
            download() {
                let self = this;
                this.loadingJobs = true;
                if (!self.isDownloading) {
                    self.isDownloading = true;
                    let url = `${this.$localApiURL}pdf/printJobDetails`;
                    Axios({
                        url: url,
                        method: 'POST',
                        responseType: 'blob', // important
                        data: {
                            token: localStorage.getItem("jwt"),
                            htmlContent: this.$refs.content.innerHTML
                        }
                    }).then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.pdf'); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        self.isDownloading = false;
                        self.loadingJobs = false;
                        self.jobsLoaded = 0;
                        self.$emit("onFileDownloaded");
                    });

                }
            }, detailLoaded() {

                if (this.jobsToPrint.length - 1 == this.jobsLoaded) {
                    this.loadingJobs = false;
                } else if (!this.loadingJobs) {
                    this.loadingJobs = true;
                }
                this.jobsLoaded++;
            }
            ,
            closeDialog() {
                this.jobsLoaded = 0;
                this.$emit("closePrintDialog");
            }


        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/PrintBookingsComponent.vue